export function padWithZeros(number: number, totalLength = 2) {
  return number.toString().padStart(totalLength, '0')
}
